import styled from 'styled-components'

export const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column' as const,
  gap: theme.space['20'],
}))

export const Section = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column' as const,
  gap: theme.space['8'],
}))

export const SectionTitle = styled.p(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.4rem',
  fontWeight: 600,
  lineHeight: '2rem',
}))

export const ItemsContainer = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray200}`,
  borderRadius: theme.border.radius['8'],
  overflow: 'hidden',
}))

export const Item = styled.div(({ theme }) => ({
  '&:nth-child(odd)': {
    backgroundColor: theme.colors.gray100,
  },
  alignItems: 'center',
  color: theme.colors.black600,
  display: 'flex',
  fontSize: '1.4rem',
  fontWeight: 500,
  gap: theme.space['8'],
  justifyContent: 'space-between',
  padding: `${theme.space['10']} ${theme.space['16']}`,
}))

export const ItemValue = styled.span(({ theme }) => ({
  color: theme.colors.black700,
  textAlign: 'right' as const,
}))

export const COILinkButton = styled.span(({ theme }) => ({
  color: theme.colors.black700,
  cursor: 'pointer',
  textAlign: 'right' as const,
  textDecoration: 'underline',
}))
